import {createAsyncThunk} from '@reduxjs/toolkit'
import AxiosClient from '../AxiosClient'

export const updateusernameAsync = createAsyncThunk(
  'user/updateUsername',
  async function (payload: object, toolkit) {
    return await AxiosClient('PUT', '/api/authenticated-user', payload, toolkit, [])
  }
)
